import { getAuthToken } from '../services/api';

async function downloadZip(jobId, name) {
  const token = getAuthToken();
  const res = await fetch(`/api/worldgen/download/${jobId}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) { alert('Download fehlgeschlagen'); return; }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${(name || 'welt').replace(/\s+/g, '_')}.zip`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

const STATUS_LABEL = {
  queued: 'Warteschlange',
  running: 'Laeuft',
  done: 'Fertig',
  error: 'Fehler',
};

const STATUS_COLOR = {
  queued: '#6b7280',
  running: '#f59e0b',
  done: '#10b981',
  error: '#ef4444',
};

export default function WorldGenJobList({ jobs, servers, onApply, onDelete }) {
  if (!jobs || jobs.length === 0) {
    return <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>Noch keine Generierungen.</p>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {jobs.map(job => (
        <div key={job.id} style={{
          background: '#1f2937', borderRadius: 8, padding: '12px 16px',
          border: '1px solid #374151', display: 'flex', flexDirection: 'column', gap: 6,
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{
                background: STATUS_COLOR[job.status] + '22',
                color: STATUS_COLOR[job.status],
                padding: '2px 8px', borderRadius: 4, fontSize: '0.75rem', fontWeight: 600,
              }}>
                {STATUS_LABEL[job.status] || job.status}
              </span>
              <span style={{ color: '#d1d5db', fontSize: '0.875rem' }}>
                {job.params?.name || 'OSM Welt'}
              </span>
              <span style={{ color: '#6b7280', fontSize: '0.75rem' }}>
                {job.params?.bbox}
              </span>
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              {job.status === 'done' && (
                <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                  {job.hasZip && (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => downloadZip(job.id, job.params?.name)}
                      style={{ padding: '4px 8px', fontSize: '0.75rem' }}
                    >
                      ZIP herunterladen
                    </button>
                  )}
                  <select
                    style={{ padding: '4px 8px', borderRadius: 4, background: '#111827', color: '#f9fafb', border: '1px solid #374151', fontSize: '0.8rem' }}
                    defaultValue=""
                    onChange={e => e.target.value && onApply(job.id, e.target.value)}
                  >
                    <option value="" disabled>Auf Server anwenden...</option>
                    {(servers || []).map(s => (
                      <option key={s.id} value={s.id}>{s.name}</option>
                    ))}
                  </select>
                </div>
              )}
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => onDelete(job.id)}
                style={{ padding: '4px 8px', fontSize: '0.75rem' }}
              >
                Loeschen
              </button>
            </div>
          </div>

          {job.status === 'running' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <div style={{ height: 6, background: '#374151', borderRadius: 3, overflow: 'hidden' }}>
                <div style={{
                  height: '100%', background: '#f97316', borderRadius: 3,
                  width: `${Math.round((job.progress || 0) * 100)}%`,
                  transition: 'width 0.4s ease',
                }} />
              </div>
              <span style={{ color: '#9ca3af', fontSize: '0.75rem' }}>
                {Math.round((job.progress || 0) * 100)}% — {job.message || '...'}
              </span>
            </div>
          )}

          {job.status === 'done' && job.stats && (
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', fontSize: '0.75rem', color: '#9ca3af' }}>
              <span>Gebaeude: {job.stats.buildings}</span>
              <span>Strassen: {job.stats.highways}</span>
              <span>Wasser: {job.stats.water_areas}</span>
              <span>Groesse: {job.stats.world_width}x{job.stats.world_height} Bloecke</span>
              <span>Zeit: {job.stats.elapsed_seconds?.toFixed(1)}s</span>
            </div>
          )}

          {job.status === 'error' && (
            <span style={{ color: '#ef4444', fontSize: '0.8rem' }}>{job.error}</span>
          )}

          <span style={{ color: '#4b5563', fontSize: '0.7rem' }}>
            {new Date(job.createdAt).toLocaleString('de-DE')}
          </span>
        </div>
      ))}
    </div>
  );
}
